module.exports = __webpack_public_path__ + "img/mf.01618424.png";